<template>
  <div class="sale-recovery-filter">
    <div class="form-group mb-0 py-5">
      <label for="dates">Período</label>
      <input
        readonly
        class="form-control bg-white"
        id="dates"
        placeholder="Selecione o período"
        @click="pickerVisible = true"
        :value="datesString(dates)"
      />
      <date-picker
        v-model="dates"
        :visible="pickerVisible"
        @hide="hidePicker"
        showCancelBtn
        positionRelative
        pickerOptions
        :pickerType="pickerType"
        @change-picker="changePicker"
      />
    </div>

    <form-group
      v-model="form.product_id"
      id="product-select"
      label="Produto"
      placeholder="Todos os produtos"
      select
      :options="productOptions"
      class="py-0"
    />

    <div class="d-flex align-items-center justify-content-between pt-6 mt-3">
      <button class="btn btn-block btn-new-secondary px-6 mr-3" @click="close">
        Cancelar
      </button>
      <button class="btn btn-block btn-primary px-6 my-0 ml-3" @click="apply">
        Aplicar
      </button>
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";
import { mapState } from "vuex";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ...formFields(
        ["product_id", "created_at_after", "created_at_before", "search"],
        {
          ...this.value
        }
      ),
      pickerVisible: false,
      pickerType: this.$store.state.sale.datePickerType,
      dates:
        this.value &&
        this.value.created_at_after &&
        this.value.created_at_before
          ? [this.value.created_at_after, this.value.created_at_before]
          : null
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    productOptions() {
      return [{ id: "", name: "Todos os produtos" }, ...this.products];
    }
  },
  methods: {
    apply() {
      this.$emit("input", this.form);
    },
    hidePicker() {
      this.pickerVisible = false;
    },
    changePicker(v) {
      this.pickerType = v;
    },
    datesString(dates) {
      const format = date =>
        date
          .split("-")
          .reverse()
          .join("/");
      return dates && dates.length === 2
        ? `${format(dates[0])} - ${format(dates[1])}`
        : "";
    },
    close() {
      this.$emit("close");
    }
  },
  watch: {
    dates(dates) {
      if (dates && dates.length === 2) {
        this.form.created_at_after = dates[0];
        this.form.created_at_before = dates[1];
      } else {
        this.form.created_at_after = null;
        this.form.created_at_before = null;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.sale-recovery-filter {
  .header {
    span {
      font-size: 18px;
      color: rgba(87, 88, 107, 0.88);
    }
    i {
      font-size: 20px;
      color: rgba(155, 157, 176, 0.86);
    }
  }
  .subtitle {
    font-size: 14px;
    color: rgba(119, 120, 142, 0.87);
  }
  ::v-deep .date-picker-component-view {
    top: auto;
    bottom: 8px;
  }
}
</style>
